<template>
  <div class="antialiased">
    <Sidebar />

    <div class="page">
      <Header 
        @change="_search"
        hint="Ketik nama mitra"
        @refresh="(filter.paginate.current_page = 1), (filter.keyword = ''), _get()"    
      />
      <div class="content">
        <div class="container">
          <div class="page-header">
            <div class="row d-flex justify-content-between pr-3">
              <div class="col-auto">
                <h2 class="page-title">Mitra</h2>
              </div>
              <div class="col-auto">
                <div class="row">
                  <div class="col-auto px-0">
                    <div class="input-icon">
                      <span class="input-icon-addon">
                        <i class="fe fe-align-left"></i>
                      </span>
                      <select
                        class="form-control pr-0"
                        v-model="filter.paginate.per_page"
                        :disabled="loading"
                      >
                        <option
                          :key="i"
                          :value="num"
                          v-for="(num, i) in [10, 50, 100, 'all']"
                          v-html="num == 'all' ? 'Semua' : num"
                        ></option>
                      </select>
                    </div>
                  </div>
                  <!--button & option-->
                  <div class="col-auto pr-0">
                    <button
                      class="btn btn-primary"
                      @click="_create()"
                    >
                      Tambah
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Skeleton
            type="table"
            :length="10"
            class="mt-3 bg-white"
            v-if="loading"
          />
          <Nodata v-if="!loading && list_mitra.length == 0" />
          <div class="card" v-if="!loading && list_mitra.length > 0">
            <div class="table-responsive">
              <table class="table table-vcenter table-hover card-table table-striped table-control">
                <thead>
                  <tr class="text-muted">
                    <th>No</th>
                    <th>Kode Mitra</th>
                    <th>Nama Mitra</th>
                    <th>Nomor Telepon</th>
                    <th>Kabupaten</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(mitra, index) in list_mitra" :key="index">

                    <td>{{ filter.paginate.from + index }}</td>
                    <td>{{ mitra.kode_mitra }}</td>
                    <td>{{ mitra.perusahaan }}</td>
                    <td>{{ mitra.telp }}</td>
                    <td>{{ mitra.kabupaten }}</td>
                    <td class="p-0 pos-relative">
                      <div class="btn-group option center">
                        <button
                          class="btn btn-white btn-pill"
                          @click="_edit(mitra)"
                          v-html="ic('edit')"
                        ></button>
                        <button
                          class="btn btn-white btn-pill text-danger"
                          @click="_delete(mitra.id)"
                          v-html="ic('trash')"
                        ></button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <b-pagination
            v-if="
              !loading &&
              list_mitra.length > 0
            "
            class="mt-5 justify-content-center"
            :total-rows="filter.paginate.total"
            v-model="filter.paginate.current_page"
            :per-page="filter.paginate.per_page"
            @change="_pageChange"
          />
        </div>
      </div>
    </div>
    <FormMitra
      :config.sync = "modal.form.config"
      :isSubmit="modal.form.isSubmit"
      :initData="modal.form.data"
      @submit="modal.form.action"
    />
    <Confirm 
      :id.sync="modal.delete.id" 
      :title.sync="modal.delete.title" 
      :isSubmit.sync="modal.delete.isSubmit" 
      @submit="modal.delete.action"
    />
  </div>
</template>


<script>
import {  mapActions } from "vuex";
import FormMitra from "./modals/form";
import helper from "@/assets/js/helper.js";

export default {
  name: "mitra",
  components: { FormMitra },
  mixins: [helper],
  data() {
    return {
      filter: {
        keyword: "",
        paginate:{
          from: 0,
          total: 0,
          per_page: 10,
          current_page: 1,
        },
      },
      loading: false,
      list_mitra: [],
      modal:{
        form: {
            config: { view: false, title: '' },
            data: {},
            isSubmit: false,
            action: () => {}
        },
        delete:{
          id: '',
          title: '',
          isSubmit: false,
          action: () => {}
        }
      }
    };
  },
  computed: {

  },
  methods: {
    ...mapActions("mitra",["list","store","update","delete"]),
    async _get(){
      try{
        this.loading = true
        const filters = {
          keyword: this.filter.keyword,
          per_page: this.filter.paginate.per_page,
          page: this.filter.paginate.current_page,
        }
        const response = await this.list(filters);
        this.list_mitra = response.data.data
        this.filter.paginate.from = response.data.from
        this.filter.paginate.total = response.data.total
      }catch(e){
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    _create(){
      this.modal.form.config = {view: true, title: 'Tambah Mitra'}
      this.modal.form.action = async (inputs) => {
        try {
          this.loading = true
          const res = await this.store(inputs)
          this._get()
          this.modal.form.isSubmit = true
        } catch (error) {
          console.log(error)
        }finally{
          this.loading = false
        }
      }

    },
    _edit(mitra){
      this.modal.form.config = {view: true, title: 'Ubah Mitra'}
      this.modal.form.data = mitra
      this.modal.form.action = async (inputs) => {
        try {
          this.loading = true
          const res = await this.update(inputs)
          this._get()
        } catch (error) {
          console.log(error)
        }finally{
          this.loading = false
        }
      }

    },
    _delete(id){
      this.modal.delete.id = id
      this.modal.delete.title = 'Yakin ingin menghapus data Mitra ini?'
      this.modal.delete.action = async () => {
        try {
          this.loading = true
          await this.delete(id)
          this.modal.delete.id = null
          this._get()
        } catch (error) {
          console.log(error)
        }finally{
          this.loading = false
        }
      }
    }, 
    _pageChange(page){
      this.filter.paginate.current_page = page;
      this._get()
    },
    _search(keyword){
        this.filter.keyword = keyword;
        this._get();
    }
  },
  mounted(){
      this._get()
  }
};
</script>